import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Chip } from '@mui/material';
import classes from './MonthFilter.module.scss';
import BasicFilterDropdown from '../BasicFilterDropdown/BasicFilterDropdown';
import { useWindowSize } from '../../../../../../utils/hooks';
import { months, responsiveSizeTimesheet } from '../../../../../../utils/constants';
import BasicDropdownOption from '../BasicDropdownOption/BasicDropdownOption';
import colors from '../../../../../../scss/colors';

export default function MonthFilter({ filterMonths, years, selectedMonth, selectedYear, changeMonth, changeYear }) {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const size = useWindowSize();

  const monthsList = [t('common.general.all'), ...(filterMonths || months(t))];

  return (
    <BasicFilterDropdown
      type={t('dashboard.timesheets.filters.month')}
      text={
        !selectedMonth || selectedMonth === t('common.general.all')
          ? t('dashboard.timesheets.filters.month')
          : selectedMonth
      }
      mobileWithHeader={false}
      active={!!selectedMonth && selectedMonth !== t('common.general.all')}
      open={open}
      setOpen={setOpen}
    >
      <div className={classes.container}>
        <div className={classes.monthsContainer}>
          {monthsList.map((month) =>
            size.width > responsiveSizeTimesheet ? (
              <BasicDropdownOption
                key={month}
                text={month}
                selected={
                  selectedMonth === month || (!selectedMonth && !selectedYear && month === t('common.general.all'))
                }
                clickHandler={() => {
                  if (!selectedYear) changeYear(years.at(-1));
                  changeMonth(month);
                  setOpen(false);
                }}
              />
            ) : (
              <Chip
                key={month}
                variant={
                  selectedMonth === month || (!selectedMonth && !selectedYear && month === t('common.general.all'))
                    ? 'filled'
                    : 'outlined'
                }
                label={month}
                onClick={() => {
                  if (!selectedYear) changeYear(years.at(-1));
                  changeMonth(month);
                }}
                sx={{
                  '&.MuiChip-root': {
                    backgroundColor:
                      selectedMonth === month || (!selectedMonth && !selectedYear && month === t('common.general.all'))
                        ? colors.NAVY_BLUE
                        : colors.PAGE_BACKGROUND,
                    color:
                      selectedMonth === month || (!selectedMonth && !selectedYear && month === t('common.general.all'))
                        ? colors.WHITE
                        : colors.MEDIUM_GREY,
                    fontStyle: 'normal',
                    fontWeight: '600',
                    fontSize: '16px',
                    lineHeight: '19px'
                  }
                }}
              />
            )
          )}
        </div>
        <div className={classes.yearsContainer}>
          {years.map((year) =>
            size.width > responsiveSizeTimesheet ? (
              <BasicDropdownOption
                key={year}
                isLeft={false}
                text={year}
                selected={selectedYear === year}
                clickHandler={() => {
                  changeYear(year);
                  setOpen(false);
                }}
              />
            ) : (
              <Chip
                variant={selectedYear === year ? 'filled' : 'outlined'}
                key={year}
                label={year}
                onClick={() => {
                  changeYear(year);
                }}
                sx={{
                  '&.MuiChip-root': {
                    backgroundColor: selectedYear === year ? colors.NAVY_BLUE : colors.PAGE_BACKGROUND,
                    color: selectedYear === year ? colors.WHITE : colors.MEDIUM_GREY,
                    fontStyle: 'normal',
                    fontWeight: '600',
                    fontSize: '16px',
                    lineHeight: '19px'
                  }
                }}
              />
            )
          )}
        </div>
      </div>
    </BasicFilterDropdown>
  );
}
